import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment-timezone";
import LocaleStrings from "Languages";
import {
  DATE_FORMAT,
  converDateIntoLocalwithmonth,
  screenHeightLeftFromTop,
} from "Constants";
import {
  fetchClientalldetails,
  fetchclientaccountusage_history,
} from "AccountSettingsAction";
import UsageHistoryitemlist from "./usagehistory-itemlist";

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class UsageHistoryBody extends Component {
  static defaultProps = {
    numberOfMonths: 2,
  };
  constructor(props) {
    super(props);
    //this.state            = this.getInitialState();
    this.state = {
      loading: true,
      desc: "Preparing Usage History",
      loader: false,
      pageNumber: 1,
      activeLoader: false,
      showPicker: false,
      stateeventid: "",
    };
  }

  componentDidMount() {
    // For Billing Info Table LIST
    let { clientdataforbilling } = this.props;
    this.props.fetchClientalldetails(
      this.props.session,
      this.props.user.clientid,
      (CallBackResponse) => {
        let group_number = null;
        let validityfrom = null;
        let validupto = null;
        if (CallBackResponse && CallBackResponse.data.length > 0) {
          group_number = CallBackResponse.data[0].group_number;
          validityfrom = moment(
            CallBackResponse.data[0].userlimitvalidityfrom
          ).format(DATE_FORMAT);
          validupto = moment(
            CallBackResponse.data[0].userlimitvalidityupto
          ).format(DATE_FORMAT);
          this.props.fetchclientaccountusage_history(
            this.props.session,
            this.props.user.clientid,
            (CallBackResponse) => {
              this.setState({ loading: false });
            }
          );
        }
      }
    );
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  renderUsagehistorylist() {
    let pageDataLength = this.props.usagehistoryDatalist.data.length;

    let { pageNumber } = this.state;

    return _.map(this.props.usagehistoryDatalist.data, (values, index) => {
      return (
        <UsageHistoryitemlist
          key={index}
          values={values}
          position={index}
          pagination={this.paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
        />
      );
    });
  }

  exportBills = (data, ShowLabel) => {
    // console.log("data", data);
    let arr = [];
    _.forEach(data, function (value, index) {
      if (Object.keys(value).length > 0) {
        delete value.userdata;

        arr.push(value); //
      }
    });
    let JSONData = {};
    JSONData["usage_history"] = arr;
    this.JSONToCSVConvertor(JSONData, ShowLabel);
  };

  JSONToCSVConvertor(JSONData, ShowLabel) {
    this.setState({ loading: true });
    var XLSX = require("xlsx");
    let wb = XLSX.utils.book_new();
    // console.log('wb',wb)
    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);
      // // var ws1 = XLSX.utils.json_to_sheet(JSONData['F2(149426)']);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");
    });
    XLSX.writeFile(wb, "usage_history.xlsx");
    this.setState({ loading: false });
  }

  render() {
    var { session, deviceSize, clientdataforbilling, usagehistoryDatalist } =
      this.props;

    let show = false;
    let firstdate = "";
    if (usagehistoryDatalist && usagehistoryDatalist.data?.length > 0) {
      firstdate = usagehistoryDatalist.data[0].firstdate
        ? moment(usagehistoryDatalist.data[0].firstdate, "YYYY-MM-DD")
        : null;

      let currentDate = moment();

      if (currentDate.isAfter(moment(firstdate))) {
        show = true;
      }
    }
    let startsfrom = "";
    if (usagehistoryDatalist && usagehistoryDatalist?.data?.length > 0) {
      startsfrom = converDateIntoLocalwithmonth(
        usagehistoryDatalist?.data[0]?.firstdate
      ).format("D MMM YYYY");
    }
    return (
      <>
        {this.state.loading ? (
          <div className="loader-container">
            {this.renderLoader()}
            <div className="loader-info">{this.state.desc}</div>
          </div>
        ) : (
          <div className="panel noborder-panel">
            <div className="clearfix" />
            <div className="" style={{ borderTop: "1px solid #fafafa" }}>
              {show == true ? (
                <div
                  className="panel-body scrollable-content"
                  style={{
                    height: deviceSize.height - (screenHeightLeftFromTop + 300),
                  }}>
                  <div className="">
                    <table className="table">
                      <thead>
                        <tr>
                          <th align="center">
                            {
                              LocaleStrings.accountsetting_usagehistory_table_th1
                            }
                          </th>
                          <th align="center">
                            {
                              LocaleStrings.accountsetting_usagehistory_table_th2
                            }
                          </th>
                          <th align="center">
                            {
                              LocaleStrings.accountsetting_usagehistory_table_th3
                            }
                          </th>
                        </tr>
                      </thead>
                      <tbody className="tbody-background">
                        {this.renderUsagehistorylist()}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div
                  className="no-content-container"
                  style={{ marginTop: "15%" }}>
                  <div className="no-content-message">
                    Usage History Calculation Starts From {startsfrom}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    activeUsrsDetails: state.activeUsrsDetails,
    clientdataforbilling: state.clientdataforbilling,
    usagehistoryDatalist: state.usagehistoryDatalist,
  };
}

export default connect(mapStateToProps, {
  fetchclientaccountusage_history,
  fetchClientalldetails,
})(UsageHistoryBody);
